import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import store from '@/store';
export default {
  inserted: function inserted(el, binding, vnode) {
    var value = binding.value;
    var all_permission = '*:*:*';
    var permissions = store.getters && store.getters.permisaction;
    if (value && value instanceof Array && value.length > 0) {
      var permissionFlag = value;

      // let ceshi = ['system:sysuser:add', 'system:sysuser:edit']
      // let ceshi = ['add', 'update']

      // const hasPermissions = ceshi.some(permission => {
      //   return all_permission === permission || permissionFlag.includes(permission)
      // })

      var hasPermissions = permissions.some(function (permission) {
        return all_permission === permission || permissionFlag.includes(permission);
      });
      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      // throw new Error(`请设置操作权限标签值`)
    }
  }
};